import React from "react";
import AnnouncementBar from "components/announcement-bar";
import HeaderBar from "components/header-bar";
import Header from "components/header";

const HeaderWrapper = ({ sliceContext, hideHeaderBar }) => {
  const { announcementBar, headerBar, headerInfo, rebrandingNotice } = sliceContext;

  return (
    <>
      {announcementBar && <AnnouncementBar data={announcementBar} />}
      {headerBar && <HeaderBar data={headerBar} />}
      {!hideHeaderBar && headerInfo?.headerSettings && <Header data={headerInfo} rebranding={rebrandingNotice} />}
    </>
  );
};
export default HeaderWrapper;